// eslint-disable-next-line @typescript-eslint/ban-ts-comment

import { LoadingState } from 'src/sdk-components/VSObject';
import { ComponentInteractionType, Inputs, Outputs, SceneComponent } from './types';

export class HTMLComponent extends SceneComponent {
  private root: any = null;

  private pivot: any = null;

  private iframeWrapperElement: HTMLDivElement;

  private iframe: any;

  private isDestroyed = false;

  inputs: Inputs = {
    url: '',
  };

  outputs = {
    loadingState: LoadingState.Idle,
  } as Outputs;

  events = {
    [ComponentInteractionType.CLICK]: true,
    [ComponentInteractionType.HOVER]: true,
    [ComponentInteractionType.DRAG]: false,
  };

  declare context: any;

  public rendererElement: any;

  onInit() {
    const THREE = this.context.three;

    if ((this.context as any).cssRenderer == null) {
      // creating CSS3D Renderer
      //const domElement = this.context.renderer.domElement;

      const vec2 = new THREE.Vector2();
      this.context.renderer.getSize(vec2);
      this.context.renderer.alpha = true;

      this.context.cssRenderer = new THREE.CSS3DRenderer({ alpha: true });
      this.context.cssRenderer.setSize(vec2.x, vec2.y);
      this.context.cssRenderer.domElement.style.position = 'absolute';
      this.context.cssRenderer.domElement.style.pointerEvents = 'none';
      this.context.cssRenderer.domElement.style.left = '0px';
      this.context.cssRenderer.domElement.style.top = '0px';
      this.context.cssRenderer.domElement.id = 'css3d';

      const iframe = document.getElementsByClassName('showcase')[0] as any;
      const canvasContainer = iframe.contentWindow.document.getElementsByTagName('main')[0];
      canvasContainer.prepend(this.context.cssRenderer.domElement);

      window.addEventListener('resize', () => {
        this.context.cssRenderer.setSize(
          document.documentElement.clientWidth,
          document.documentElement.clientHeight,
        );
      });

      this.context.cssRendererBuffer = new THREE.WebGLRenderTarget(
        window.innerWidth,
        window.innerHeight,
        {
          minFilter: THREE.LinearFilter,
          magFilter: THREE.NearestFilter,
        },
      );
    }

    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();

    this.root.add(this.pivot);
    this.outputs.objectRoot = this.root;

    this.pivot.scale.x = 0.001;
    this.pivot.scale.y = 0.001;
    this.pivot.scale.z = 0.001;

    this.outputs.loadingState = LoadingState.Loading;
    this.rendererElement = this.context.cssRenderer.domElement;

    this.makeIFrame(this.inputs.url)
      .then(() => {
        this.outputs.loadingState = LoadingState.Loaded;
      })
      .catch(() => {
        this.outputs.loadingState = LoadingState.Error;
      });

    this.context.renderer.xr.addEventListener('sessionstart', () => {
      this.iframe.visible = false;
    });
    this.context.renderer.xr.addEventListener('sessionend', () => {
      this.iframe.visible = true;
    });
  }

  onDestroy() {
    if (this.iframe) {
      this.context.cssRenderer.domElement.remove();
      this.iframe.element = null;
      this.iframe.parent?.remove(this.iframe);
      this.isDestroyed = true;
    }
  }

  private async makeIFrame(src): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.iframe) {
        this.iframe.geometry.dispose();
        this.iframe.material.dispose();
      }

      const THREE = this.context.three;

      this.iframeWrapperElement = document.createElement('div');

      const iframeElement = document.createElement('iframe');
      iframeElement.src = src;
      this.iframeWrapperElement.appendChild(iframeElement);

      iframeElement.onload = () => resolve();
      iframeElement.onerror = () => reject();

      this.iframeWrapperElement.style.width = `${window.innerWidth}px`;
      this.iframeWrapperElement.style.height = `${window.innerHeight}px`;
      iframeElement.style.width = `${window.innerWidth}px`;
      iframeElement.style.height = `${window.innerHeight}px`;
      this.iframeWrapperElement.style.background = '#FFFFFF';
      this.iframe = new THREE.CSS3DObject(this.iframeWrapperElement);

      this.pivot.add(this.iframe);
    });
  }

  onTick() {
    if (!this.isDestroyed) this.context.cssRenderer.render(this.pivot, this.context.camera);
  }
}

export const htmlComponentType = 'mp.htmlComponent';
export const makeHTMLComponent = (): any => new HTMLComponent();
